import { Factory } from 'fishery';
import { Picklist } from '@trukt/types/Picklist';

export const picklistFactory = Factory.define<Picklist>(({ sequence }) => ({
  dateFilterTerms: {
    statusTypes: {
      options: [
        {
          label: 'Job Manually Dispatched',
          value: 31,
        },
        {
          label: 'Job Rolled Back To Pick Up On',
          value: 32,
        },
        {
          label: 'Commodity Deleted On',
          value: 33,
        },
        {
          label: 'Set To In Progress',
          value: 34,
        },
        {
          label: 'Job Completed On',
          value: 35,
        },
        {
          label: 'Job Uncompleted On',
          value: 36,
        },
        {
          label: 'TONU',
          value: 37,
        },
        {
          label: 'Tender Created',
          value: 38,
        },
        {
          label: 'Job Rolled Back To In Progress',
          value: 39,
        },
        {
          label: 'Job Hold Removed',
          value: 40,
        },
        {
          label: 'Created On',
          value: 1,
        },
        {
          label: 'Posted On',
          value: 2,
        },
        {
          label: 'Un-Posted On',
          value: 3,
        },
        {
          label: 'Tender Accepted',
          value: 8,
        },
        {
          label: 'Tender Declined',
          value: 9,
        },
        {
          label: 'Accepted On',
          value: 13,
        },
        {
          label: 'Offer Sent On',
          value: 10,
        },
        {
          label: 'Manually Accepted On',
          value: 11,
        },
        {
          label: 'Offer Canceled On',
          value: 12,
        },
        {
          label: 'Dispatch Declined On',
          value: 14,
        },
        {
          label: 'Self Assigned On',
          value: 15,
        },
        {
          label: 'Set To Ready On',
          value: 16,
        },
        {
          label: 'Job Deleted On',
          value: 17,
        },
        {
          label: 'Job Undeleted On',
          value: 18,
        },
        {
          label: 'Removed On',
          value: 21,
        },
        {
          label: 'Set On Hold On',
          value: 22,
        },
        {
          label: 'Job Canceled On',
          value: 23,
        },
        {
          label: 'Job Uncanceled On',
          value: 24,
        },
        {
          label: 'Job Delivered On',
          value: 27,
        },
        {
          label: 'Job Pick Up On',
          value: 29,
        },
      ],
    },
  },
  transportTypes: {
    options: [
      {
        label: 'Transport',
        value: 1,
      },
    ],
  },
  serviceTypes: {
    options: [
      {
        label: 'Locksmith',
        value: 2,
      },
      {
        label: 'Unloading',
        value: 3,
      },
      {
        label: 'Loading',
        value: 4,
      },
      {
        label: 'Repair',
        value: 5,
      },
      {
        label: 'Diagnostics',
        value: 6,
      },
      {
        label: 'Repossession',
        value: 8,
      },
      {
        label: 'Storage',
        value: 9,
      },
      {
        label: 'Registration Services',
        value: 10,
      },
    ],
  },
  commodityTypes: {
    commodityTypes: {
      options: [
        {
          label: 'Vehicles',
          value: 'vehicle',
        },
        {
          label: 'Freight',
          value: 'freight',
        },
      ],
    },
    freight: {
      options: [
        {
          label: 'Bulk',
          value: 21,
        },
        {
          label: 'Crushed Cars',
          value: 22,
        },
        {
          label: 'Other',
          value: 23,
        },
        {
          label: 'Pallets',
          value: 24,
        },
      ],
    },
    vehicles: {
      options: [
        {
          label: 'Coupe',
          value: 1,
        },
        {
          label: 'Convertible',
          value: 2,
        },
        {
          label: 'Sedan',
          value: 3,
        },
        {
          label: 'SUV',
          value: 4,
        },
        {
          label: 'Minivan',
          value: 5,
        },
        {
          label: 'Pickup Truck (2 Door)',
          value: 6,
        },
        {
          label: 'Pickup Truck (4 Door)',
          value: 7,
        },
        {
          label: 'Pickup Dually',
          value: 8,
        },
        {
          label: 'Motorcycle',
          value: 9,
        },
        {
          label: 'ATV',
          value: 10,
        },
        {
          label: 'Boat',
          value: 11,
        },
        {
          label: 'RV',
          value: 12,
        },
        {
          label: 'Trailer (5th Wheel)',
          value: 13,
        },
        {
          label: 'Trailer (Bumper Pull)',
          value: 14,
        },
        {
          label: 'Trailer (Gooseneck)',
          value: 15,
        },
        {
          label: 'Cargo Van',
          value: 16,
        },
        {
          label: 'Box Truck',
          value: 17,
        },
        {
          label: 'Day Cab',
          value: 18,
        },
        {
          label: 'Sleeper Cab',
          value: 19,
        },
        {
          label: 'Other',
          value: 20,
        },
      ],
    },
  },
  equipmentTypes: {
    options: [
      {
        label: 'Open',
        value: 1,
      },
      {
        label: 'Enclosed',
        value: 2,
      },
      {
        label: 'Van',
        value: 3,
      },
      {
        label: 'Flatbed',
        value: 4,
      },
      {
        label: 'Step Deck',
        value: 5,
      },
      {
        label: 'Lowboy / RGN',
        value: 6,
      },
      {
        label: 'Reefer',
        value: 7,
      },
      {
        label: 'Flatbed/Van/Reefer',
        value: 8,
      },
      {
        label: 'Power Only',
        value: 9,
      },
      {
        label: 'Driveaway',
        value: 10,
      },
      {
        label: 'Box Truck',
        value: 11,
      },
      {
        label: 'Lowboy',
        value: 12,
      },
      {
        label: 'RGN',
        value: 13,
      },
      {
        label: 'Hot Shot',
        value: 14,
      },
      {
        label: 'Sprinter Van',
        value: 15,
      },
      {
        label: 'Van/Reefer',
        value: 16,
      },
      {
        label: 'Van/Flatbed/Step Deck',
        value: 17,
      },
      {
        label: 'Flatbed/Step Deck',
        value: 18,
      },
      {
        label: 'Van W/Team',
        value: 19,
      },
      {
        label: 'Van / Sprinter Van / Box Truck',
        value: 20,
      },
      {
        label: 'Flatbed / Step Deck / Hotshot',
        value: 21,
      },
      {
        label: 'Flatbed / Step Deck / Hotshot / Lowboy / RGN',
        value: 22,
      },
      {
        label: 'Chasis',
        value: 23,
      },
    ],
  },
  inspectionTypes: {
    options: [
      {
        label: 'Standard',
        value: 'standard',
      },
      {
        label: 'Advanced',
        value: 'advanced',
      },
      {
        label: 'AIAG',
        value: 'AIAG',
      },
    ],
  },
  conditionTypes: {
    options: [
      {
        label: 'Inoperable',
        value: 'yes',
      },
      {
        label: 'Operable',
        value: 'no',
      },
      {
        label: 'Not Verified',
        value: 'unknown',
      },
    ],
  },

  vehicleWeightClasses: {
    options: [
      {
        label: '1',
        value: 1,
        minWeight: 0,
        maxWeight: 6000,
      },
      {
        label: '2',
        value: 2,
        minWeight: 6001,
        maxWeight: 10000,
      },
      {
        label: '3',
        value: 3,
        minWeight: 10001,
        maxWeight: 14000,
      },
      {
        label: '4',
        value: 4,
        minWeight: 14001,
        maxWeight: 16000,
      },
      {
        label: '5',
        value: 5,
        minWeight: 16001,
        maxWeight: 19500,
      },
      {
        label: '6',
        value: 6,
        minWeight: 19501,
        maxWeight: 26000,
      },
      {
        label: '7',
        value: 7,
        minWeight: 26001,
        maxWeight: 33000,
      },
      {
        label: '8',
        value: 8,
        minWeight: 33001,
        maxWeight: 999999,
      },
    ],
  },
}));
